import script from "./Slider.Map.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.Map.vue?vue&type=script&setup=true&lang=js"

import "./Slider.Map.vue?vue&type=style&index=0&id=1b056bf8&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b056bf8"]])

export default __exports__